exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".access-denied{display:flex;justify-content:center;align-items:center;width:100%;height:100%}.access-denied__body{max-width:600px}.access-denied__header{font-size:24px;text-align:center}.access-denied__header .k-icon{margin-right:5px;vertical-align:-5px;font-size:28px;display:inline-block}.access-denied__text{margin-top:20px}.access-denied__text code{margin-left:5px}", ""]);

// exports
